import { PRIORITY, TASK_PROGRESS } from 'types'
import type { OptionProps, IColumn } from 'types'

import { routes } from 'helpers/routes'
import { Breadcrumb } from 'recoils/atoms'

export const HEADERS: IColumn[] = [
  {
    key: 'code',
    label: 'ticket:ticketId.column',
    sortable: true,
    width: 7,
  },
  {
    key: 'statusProgress',
    label: 'common:header.status.label',
    sortable: true,
    width: 7,
  },
  {
    key: 'name',
    label: 'ticket:product.column',
    sortable: false,
    width: 12,
    className: 'multiline',
  },
  {
    key: 'issueDetail',
    label: 'ticket:description.column',
    sortable: true,
    width: 16,
    className: 'multiline',
  },
  {
    key: 'requestDate',
    label: 'ticket:requestDate.column',
    sortable: true,
    width: 6,
  },
  {
    key: 'statusPriority',
    label: 'ticket:priority.column',
    sortable: true,
    width: 6,
  },
  {
    key: 'companyName',
    label: 'company:header.name.label',
    sortable: true,
    width: 10,
    className: 'multiline',
  },
  {
    key: 'branchName',
    label: 'branch:header.name.label',
    sortable: true,
    width: 10,
    className: 'multiline',
  },
]

export const HEADERS_LOADING = [
  {
    key: 'no',
    label: '',
    sortable: false,
    width: 25,
  },
  {
    key: 'requestDate',
    label: '',
    sortable: false,
    width: 25,
  },
  {
    key: 'branchName',
    label: '',
    sortable: false,
    width: 25,
  },
  {
    key: 'area',
    label: '',
    sortable: false,
    width: 25,
  },
]

export const COLUMNS_SELECT_BRANCH: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 6,
  },
  {
    key: 'name',
    label: 'branch:header.name.label',
    sortable: true,
    width: 32,
  },
  {
    key: 'companyName',
    label: 'company:header.name.label',
    sortable: true,
    width: 32,
  },
  {
    key: 'phone',
    label: 'branch:header.contactNumber.label',
    sortable: false,
    width: 14,
  },
  {
    key: 'selectBranch',
    label: '',
    sortable: false,
    width: 14,
  },
]

export const COLUMNS_SELECT_BRANCH_LOADING: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 38,
  },
  {
    key: 'companyName',
    label: 'company:header.name.label',
    sortable: true,
    width: 32,
  },
  {
    key: 'phone',
    label: 'branch:header.contactNumber.label',
    sortable: false,
    width: 14,
  },
  {
    key: 'selectBranch',
    label: '',
    sortable: false,
    width: 14,
  },
]

export const COLUMNS_PROGRESS_INFO: IColumn[] = [
  {
    key: 'createdAt',
    label: 'ticket:date.column',
    sortable: false,
    width: 16,
  },
  {
    key: 'status',
    label: 'common:header.status.label',
    sortable: false,
    width: 12,
  },
  {
    key: 'subject',
    label: 'ticket:subject.column',
    sortable: false,
    width: 14,
  },
  {
    key: 'updatedByFullName',
    label: 'ticket:updatedByFullName.column',
    sortable: false,
    width: 16,
  },
  {
    key: 'detail',
    label: 'ticket:detail.column',
    sortable: false,
    width: 42,
    textAlign: 'left',
  },
]

export const COLUMNS_HISTORY: IColumn[] = [
  {
    key: 'code',
    label: 'ticket:ticketId.column',
    sortable: true,
    width: 15,
  },
  {
    key: 'completedAt',
    label: 'ticket:completionDate.column',
    sortable: true,
    width: 20,
  },
  {
    key: 'issueType',
    label: 'ticket:type.column',
    sortable: true,
    width: 25,
  },
  {
    key: 'detail',
    label: 'ticket:remark.column',
    sortable: true,
    width: 40,
  },
]

export const TICKET_BRANCH_MAIN_HEADERS: IColumn[] = [
  {
    key: 'customerDetail',
    label: 'ticket:customerDetail.column',
    width: 100,
    textAlign: 'left',
  },
]

export const TICKET_BRANCH_HEADERS: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    width: 10,
  },
  {
    key: 'name',
    label: 'branch:header.name.label',
    width: 26,
  },
  {
    key: 'companyName',
    label: 'company:header.name.label',
    width: 28,
  },
  {
    key: 'phone',
    label: 'ticket:phone.column',
    width: 26,
  },
  {
    key: 'icon',
    label: '',
    width: 10,
  },
]

export const TICKET_PRODUCTS_BY_BRANCH_HEADERS: IColumn[] = [
  {
    key: 'selected',
    label: 'common:selectProduct.label',
    width: 10,
    textAlign: 'left',
  },
  {
    key: 'image',
    label: 'common:productImage.label',
    width: 20,
    textAlign: 'left',
  },
  {
    key: 'name',
    label: 'common:productName.label',
    width: 45,
    textAlign: 'left',
  },
  {
    key: 'serialNumber',
    label: 'common:serialNumber.label',
    width: 25,
    textAlign: 'left',
  },
]

export const TICKET_BRANCH_PRODUCT_HEADERS: IColumn[] = [
  {
    key: 'radio',
    label: '',
    width: 10,
  },
  {
    key: 'image',
    label: '',
    width: 14,
  },
  {
    key: 'detail',
    label: 'ticket:productName.column',
    width: 46,
  },
  {
    key: 'history',
    label: '',
    width: 30,
  },
]

export const TICKET_BRANCH_PRODUCT_DETAIL_HEADERS: IColumn[] = [
  {
    key: 'name',
    label: 'ticket:productName.column',
    width: 20,
  },
  {
    key: 'serialNumber',
    label: 'ticket:serialNumber.column',
    width: 20,
  },
]

export const PRIORITY_FORM_OPTIONS: OptionProps[] = [
  {
    key: PRIORITY.HIGH,
    label: 'common:high.label',
  },
  {
    key: PRIORITY.MEDIUM,
    label: 'common:medium.label',
  },
  {
    key: PRIORITY.LOW,
    label: 'common:low.label',
  },
]

export const PRIORITY_OPTIONS: OptionProps[] = [
  ...PRIORITY_FORM_OPTIONS,
  {
    key: '',
    label: 'common:all.label',
  },
]

export const TICKET_OPTIONS: OptionProps[] = [
  {
    key: TASK_PROGRESS.NEW,
    label: 'ticket:unassign.status',
    isSelect: false,
  },
  {
    key: TASK_PROGRESS.IN_PROGRESS,
    label: 'ticket:inProgress.status',
    isSelect: false,
  },
  {
    key: TASK_PROGRESS.PENDING,
    label: 'ticket:pending.status',
    isSelect: false,
  },
  {
    key: TASK_PROGRESS.TRANSFERRING,
    label: 'ticket:transferring.status',
    isSelect: false,
  },
  {
    key: TASK_PROGRESS.REJECTED,
    label: 'ticket:rejected.status',
    isSelect: false,
  },
  {
    key: TASK_PROGRESS.DONE,
    label: 'ticket:done.status',
    isSelect: false,
  },
  {
    key: TASK_PROGRESS.CLOSED,
    label: 'ticket:closed.status',
    isSelect: false,
  },
  {
    key: '',
    label: 'common:all.label',
    isSelect: false,
  },
]

export const HEADER_DOWNLOAD_TICKETS = [
  [
    'Created By',
    'Created Date',
    'Created Time',
    'Updated By',
    'Updated Date',
    'Updated Time',
    'Deleted By',
    'Deleted Date',
    'Deleted Time',
    'Task ID',
    'Ticket Number',
    'Report Date',
    'Report Time',
    'Priority',
    'Status Ticket',
    'Start Assign Date',
    'Start Assign Time',
    'End Assign Date',
    'End Assign Time',
    'Issue Detail',
    'Ticket Type',
    'Issue Type',
    'Reporter',
    'Email Reporter',
    'Reporter Phone Number',
    'Company Name',
    'Branch Name',
    'Branch Address',
    'Created From',
    'Technicians',
    'Check-in Date',
    'Check-in Time',
    'User Check-in',
    'Pending Date',
    'Pending Time',
    'User Pending',
    'Pending Detail',
    'Complete Date',
    'Complete Time',
    'Completed By',
    'Complete Detail',
    'Closed Task Detail',
    'Closed Task Date',
    'Closed Task Time',
    'Closed Task Rating',
    'Rejected Detail',
    'Rejected Date',
    'Rejected Time',
    'Transfer Date',
    'Transfer Time',
    'Transfer By',
    'Transfer Detail',
    'Product Name',
    'Complete Detail By Technician',
  ],
]

export const FILENAME = {
  TASK_DETAIL_PDF: 'Service-Form',
}

export const BREADCRUMBS_LIST: Breadcrumb[] = [
  {
    key: routes.ticket.path,
    label: 'layout:ticketManagement.breadcrumb',
  },
]

export const BREADCRUMBS_SELECT_BRANCH_LIST: Breadcrumb[] = [
  {
    key: routes.ticket.path,
    label: 'layout:ticketManagement.breadcrumb',
  },
  {
    key: routes.ticket.branch.path,
    label: 'layout:ticketSelectBranch.breadcrumb',
  },
]

export const BREADCRUMBS_CREATE_TICKET: Breadcrumb[] = [
  {
    key: routes.ticket.path,
    label: 'layout:ticketManagement.breadcrumb',
  },
  {
    key: routes.ticket.branch.path,
    label: 'layout:ticketSelectBranch.breadcrumb',
  },
  {
    key: routes.ticket.branch.create.path,
    label: 'layout:createTicket.breadcrumb',
  },
]

export const renderBreadcrumbsDetail = (id: string): Breadcrumb[] => [
  {
    key: routes.ticket.path,
    label: 'layout:ticketManagement.breadcrumb',
  },
  {
    key: `${routes.ticket.path}/${id}/detail`,
    label: 'layout:ticketDetail.breadcrumb',
  },
]
